import store from '../../store'
import  pwa_generate from './pwa_generate.vue'

window.PWA_GENERATE=  new Vue({
    store,
    el: '#pwa_generate',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pwa_generate
    }
});
